var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "items-container" },
    [
      _vm.invalidRowsCount > 0
        ? _c("div", { staticClass: "items-error-count" }, [
            _c("svg", { staticClass: "items-error-count-icon" }, [
              _c("use", { attrs: { "xlink:href": "#exclamation-heavy" } })
            ]),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t("items.bulk.error.invalidSkusToBeFixed", {
                    count: _vm.invalidRowsCount
                  })
                ) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm.parent.items.length > 0
        ? _c("base-table", {
            ref: "table-" + _vm.parent.id,
            attrs: {
              columns: _vm.columns,
              rows: _vm.parent.items,
              actions: _vm.itemsActionsComputed,
              "row-uniq-id": "idx"
            },
            scopedSlots: _vm._u([
              {
                key: "column-default-tpl",
                fn: function(ref) {
                  var row = ref.row
                  var col = ref.col
                  var colIdx = ref.colIdx
                  return [
                    _c(
                      "field-wrapper",
                      {
                        attrs: {
                          "for-id": "i_" + colIdx + "-" + row.idx + "-input",
                          "hide-label": true,
                          error:
                            _vm.getColError(row, col) ||
                            _vm.getServerSideError(row, col)
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "cell-container",
                            class: {
                              "cell-custom-error":
                                row.errorMessage &&
                                row.errorMessage.length &&
                                col.field == "sku"
                            }
                          },
                          [
                            col.field === "isSerialSku" &&
                            _vm.isVisibleRecordSerialNumber &&
                            row.isRecordSerialNumber
                              ? _c(
                                  "span",
                                  [
                                    _c("button-tooltip", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.bottom",
                                          value: {
                                            content: _vm.$t(
                                              "items.labels.isRecordSerialNumberWillCaptureToolTip"
                                            ),
                                            delay: { show: 500, hide: 300 }
                                          },
                                          expression:
                                            "{\n                                content: $t('items.labels.isRecordSerialNumberWillCaptureToolTip'),\n                                delay: { show: 500, hide: 300 },\n                            }",
                                          modifiers: { bottom: true }
                                        }
                                      ],
                                      attrs: { "display-star": true }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            col.field === "expirationDate"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("valueOrDash")(
                                        _vm._f("date")(row[col.field], "short")
                                      )
                                    )
                                  )
                                ])
                              : col.field != "quantity"
                              ? _c("span", [_vm._v(_vm._s(row[col.field]))])
                              : _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("valueOrDash")(row[col.field])
                                      ) +
                                      "\n                        "
                                  ),
                                  !_vm.hideAvailableQty
                                    ? _c("span", [_vm._v(" / ")])
                                    : _vm._e(),
                                  !_vm.hideAvailableQty
                                    ? _c(
                                        "span",
                                        {
                                          class: {
                                            "no-items-error": !_vm.getAvailableCount(
                                              row
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm._f("valueOrDash")(
                                                  _vm.getAvailableCount(row)
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                            (_vm.getColError(row, col) != null &&
                              _vm.getColError(row, col).length > 0) ||
                            _vm.getServerSideError(row, col) != null
                              ? _c("svg", { staticClass: "item-error-icon" }, [
                                  _c("use", {
                                    attrs: {
                                      "xlink:href": "#exclamation-heavy"
                                    }
                                  })
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }